import React from 'react';
import NotificationsIndexPage from '../notifications_index_page/NotificationsIndexPage';
import {
	NOTIFICATION_NOTES_TYPES,
	SUPPLIER_NOTIFICATION_NOTES_TYPES,
	UNREAD_NOTIFICATION_TYPES,
} from '../../utils/NotificationUtils';
import { connect } from 'react-redux';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';

function NotificationsNotes({
	fetchUserNotificationsCountForSupplier,
	fetchUserNotificationsCountForBuyer,
	userType,
}) {
	const fetchUserNotificationsCount =
		userType === ROLE_TYPES.BUYER
			? fetchUserNotificationsCountForBuyer
			: fetchUserNotificationsCountForSupplier;

	// Suppliers additionally see contractor-side notes, which the backend
	// classifies under separate notification types. (OPE-5106)
	const notesTypes =
		userType === ROLE_TYPES.SUPPLIER ? SUPPLIER_NOTIFICATION_NOTES_TYPES : NOTIFICATION_NOTES_TYPES;

	return (
		<NotificationsIndexPage
			key={'NotificationsNotes'}
			preAppliedFilters={{
				hasSeen: false,
			}}
			onNotificationClick={() => {
				fetchUserNotificationsCount(UNREAD_NOTIFICATION_TYPES, 'TASKS_NOTIFICATIONS');
			}}
			notificationTypes={notesTypes
				.map((filter) => (filter.children ? filter.children.map((child) => child.key) : filter.key))
				.flat()}
			typeFilters={notesTypes}
		/>
	);
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	userType: state.session.userType,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsNotes);
